import {openDB} from 'idb';

const DB_NAME = 'GenericDB';
const DB_VERSION = 1;
const STORE_NAME = 'items';

export const initDB = async () => {
    return await openDB(DB_NAME, DB_VERSION, {
        upgrade(db) {
            if (!db.objectStoreNames.contains(STORE_NAME)) {
                db.createObjectStore(STORE_NAME);
            }
        }
    });
};

export const addItem = async (key: string, value: any) => {
    const db = await initDB();
    const tx = db.transaction(STORE_NAME, 'readwrite');
    const store = tx.objectStore(STORE_NAME);
    await store.put(value, key);
    await tx.done;
};

export const getItems = async () => {
    const db = await initDB();
    return db.getAll(STORE_NAME);
};

export const getItemByKey = async (key: string) => {
    const db = await initDB();
    const tx = db.transaction(STORE_NAME, 'readonly');
    const store = tx.objectStore(STORE_NAME);
    const item = await store.get(key);
    await tx.done;
    return item;
};

export const clearItems = async () => {
    const db = await initDB();
    return db.clear(STORE_NAME);
};

export const removeItemByKey = async (key: string) => {
    const db = await initDB();
    const tx = db.transaction(STORE_NAME, 'readwrite');
    const store = tx.objectStore(STORE_NAME);
    await store.delete(key);
    await tx.done;
};

export const clearAllDatabases = async (): Promise<boolean> => {
    const deleteDatabase = (): Promise<boolean> => {
        return new Promise((resolve, reject) => {
            const request: IDBOpenDBRequest = window.indexedDB.deleteDatabase(DB_NAME);

            request.onsuccess = (ev) => {
                console.log(`Database ${DB_NAME} deleted successfully.`);
                console.log(ev);
                resolve(true);
            };

            request.onerror = (ev) => {
                console.error(`Failed to delete database ${DB_NAME}.`);
                console.error(ev);
                reject(false);
            };

            request.onblocked = (ev) => {
                console.error(`Failed to delete database ${DB_NAME} due to the operation being blocked.`);
                console.error(ev);
                reject(false);
            }

        });
    };

    try {
        // 첫 번째 시도
        return await deleteDatabase();
    } catch (error) {
        console.log("Retrying to delete the database...");
        // 에러 발생 시 한 번 더 시도
        try {
            return await deleteDatabase();
        } catch (secondError) {
            console.error("Failed again to delete the database.");
            return false;
        }
    }
};

const dbPromise = openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
        db.createObjectStore(STORE_NAME);
    },
});


export const idbItems = {
    get: async (key: string) => {
        return (await dbPromise).get(STORE_NAME, key);
    },
    set: async (key: string, val: any) => {
        if (val === undefined) { return; }
        return (await dbPromise).put(STORE_NAME, val, key);
    },
    del: async (key: string) => {
        return (await dbPromise).delete(STORE_NAME, key);
    },
    clear: async () => {
        return (await dbPromise).clear(STORE_NAME);
    },
    getAllKeys: async () => {
        return (await dbPromise).getAllKeys(STORE_NAME);
    },
    gets: async (keys: string[]): Promise<(string | undefined)[]> => {
        const db = await dbPromise;
        const tx = db.transaction(STORE_NAME, 'readonly');
        const store = tx.objectStore(STORE_NAME);
        const requests = keys.map(key => store.get(key));
        const results = await Promise.allSettled(requests);
        return results.map(result => {
            if (result.status === 'fulfilled') {
                return result.value;
            }
            return undefined;
        });
    },
    getAll: async () => { // 전체 아이템 가져오기
        return (await dbPromise).getAll(STORE_NAME);
    },
 
}
